import type { Note } from '../hooks/useApi';

export function getNoteAverageRating(note: Pick<Note, 'rating' | 'ratingCount' | 'averageRating'>): number {
  if (note.ratingCount > 0) {
    return Number((note.rating / note.ratingCount).toFixed(1));
  }
  const avg = Number(note.averageRating);
  return Number.isFinite(avg) ? avg : 0;
}

export const LOW_RATING_MAX = 2;
